// Componente para a aba 2 - Gerenciamento dos Anexos.

import React, { useState } from "react";
import axios from "axios";

const AnexoTabAners = ({
    id,
    token,
    responseProcess,
    responseAnexo,
    fileList,
    dataFormato,
    responseParam,
}) => {
    // Estado para controlar a quantidade de arquivos adicionados
    const [selectedFilesCount, setSelectedFilesCount] = useState(0);

    function deleteAnexo(n) {
        axios
            .post(
                `/api/remove/attachment/${n}`,
                { token, responseParam },
                {
                    withCredentials: true,
                }
            )
            .then((response) => {
                window.location = response.data;
            });
    }

    // Funções auxiliares de arquivos

    function removeAttachment(i) {
        const upload = document.querySelector("#upload");
        const divUpload = document.querySelector("#novosAnexos");
        const attachments = divUpload.querySelectorAll(".row"); // obtém todos os elementos .row dentro do divUp1

        let files = upload.files;
        const dt = new DataTransfer();
        for (let c = 0; c < files.length; c++) {
            console.log("++++++++++", files[c]);
            if (c !== i) {
                dt.items.add(files[c]);
            }
        }

        const newFiles = dt.files;
        console.log(newFiles[0]);
        upload.files = newFiles;
        console.log(upload.files[0]);
        // Remove o elemento no índice i da lista de anexos
        console.log("Antes de remover: " + i);
        fileList.items.remove(i);
        attachments[i].remove();
        const newDivUpload = document.querySelector("#novosAnexos");
        const icon = newDivUpload.querySelectorAll("i");
        const attach = newDivUpload.querySelectorAll(".row");
        console.log("len: " + icon.length);
        for (let cont = 0; cont < icon.length; cont++) {
            console.log(cont);
            icon[cont].onclick = () => removeAttachment(cont);
        }
        // Atualiza a contagem dos arquivos adicionados
        setSelectedFilesCount(newFiles.length);
    }

    const handleFileUpload = (event) => {
        let file = event.target.files;
        // Atualiza o estado com a quantidade de arquivos selecionados
        setSelectedFilesCount(file.length);

        for (let i = 0; i < file.length; i++) {
            fileList.items.add(file[i]);
            const divUpload = document.querySelector("#divUp1");
            //const newAtt = document.querySelector('#newAttach');
            const novos = document.querySelector("#novosAnexos");
            const rowDiv = document.createElement("div");
            rowDiv.className = "row";

            const col7Div = document.createElement("div");
            col7Div.className = "col-12";

            const label = document.createElement("label");
            label.textContent = `${file[i].name}`;
            const spanUpload = document.createElement("span");
            spanUpload.className = "hidden-xs";
            const iconUp = document.createElement("i");
            iconUp.className =
                "fa fa-minus-circle ml-3 btn-remove-anexo text-danger";
            iconUp.style.fontSize = "1.25em";
            iconUp.style.position = "relative";
            iconUp.style.top = ".15em";
            iconUp.onclick = () => removeAttachment(i);
            spanUpload.appendChild(iconUp);
            col7Div.appendChild(label);
            col7Div.appendChild(spanUpload);
            rowDiv.appendChild(col7Div);

            //divUpload.insertBefore(rowDiv, newAtt)
            novos.appendChild(rowDiv);
        }

        event.target.files = fileList.files;
        console.log("Files: " + file);

        const newDivUpload = document.querySelector("#novosAnexos");
        const icon = newDivUpload.querySelectorAll("i");
        for (let i = 0; i < icon.length; i++) {
            icon[i].onclick = () => removeAttachment(i);
        }
    };

    function clickUploadAnexo(event) {
        const inputFile = document.getElementById("upload");
        inputFile.click();
    }

    return (
        <div className="tab-pane fade" id={id} role="tabpanel">
            <div className="card-body table-responsive p-0">
                <table className="table table-striped table-bordered mt-10">
                    <tbody>
                        <tr></tr>
                        <tr>
                            <th>Número do Processo</th>
                            <th>Data da Inserção do Anexo</th>
                            <th>Nome do Anexo</th>
                            <th>Referente</th>
                            <th>Ação</th>
                        </tr>
                        {responseAnexo.map((dados) => (
                            <tr key={dados.id}>
                                <th>{responseProcess.processo}</th>
                                <th>{dataFormato(dados.data)}</th>
                                <th>
                                    <label title="Clique para visualizar o arquivo">
                                        <a
                                            style={{ color: "green" }}
                                            href={`https://guias.almeidaenogueira.com.br/api/download/${dados.id}`}>
                                            <i className="fa fa-cloud-download mr-3" />
                                            {dados.nome}
                                        </a>
                                    </label>
                                </th>
                                <th>{dados.referente}</th>
                                <th className="center-element">
                                    <button
                                        className="btn btn-danger"
                                        type="button"
                                        title="Excluir"
                                        onClick={() => deleteAnexo(dados.id)}>
                                        <i className="fa fa-trash" />
                                    </button>
                                </th>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <form
                action={`/api/new/attachment/${responseParam}`}
                method="post"
                encType="multipart/form-data">
                <div style={{ marginTop: 13 }} className="col-12" id="divUp1">
                    <div className="row">
                        <div className="col-7">
                            <h5>Novos anexos</h5>
                        </div>
                        <div className="col-4 form-group">
                            <input
                                name="upload"
                                id="upload"
                                type="file"
                                multiple
                                onChange={handleFileUpload}
                            />
                        </div>
                        <div className="col-1">
                            <button
                                type="button"
                                className="btn btn-success"
                                id="botao"
                                onClick={clickUploadAnexo}>
                                <i className="fa fa-plus" />
                            </button>
                        </div>
                    </div>
                    <div id="novosAnexos"></div>
                    <div className="row" id="newAttach">
                        <div className="col-12 center-element">
                            <button
                                type="submit"
                                className="btn bg-success"
                                disabled={selectedFilesCount === 0}>
                                Salvar
                            </button>
                        </div>
                    </div>
                    <hr className="hr" />
                </div>
            </form>
        </div>
    );
};

export default AnexoTabAners;
